import request, { requestbody, requestBlob } from './request.js';

export async function page(params = {}) {
    return await request('/declarationArchive/page', 'get', params);
}

export async function summary(params = {}) {
    return await request('/declarationArchive/summary', 'get', params);
}

export async function batchAcquire(params = {}) {
    return await requestbody('/declarationArchive/batchAcquire', 'post', params);
}

export async function screenshotContent(params = {}) {
    return await requestBlob('/declarationArchive/screenshot/content', 'get', params);
}
